module.exports = __webpack_public_path__ + "03d8e192aabf5ccef4d7abf47eeab912.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/entrance/assets/headerBg.jpg
// module id = 811
// module chunks = 0